import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

// Home card when a letter from your past self has arrived and hasn't been opened yet
export const LetterArrivedCard = () => {
  const [u, setU] = useState(null);
  useEffect(() => { api.get("/letters/unread").then((r) => setU(r.data)).catch((e) => logError("Letters unread failed:", e)); }, []);
  if (!u?.count) return null;
  const l = u.latest;
  return (
    <Link to={`/letters?open=${l.id}`} className="mm-paper rounded-3xl p-5 mb-6 flex items-center gap-4 border border-mm-primary/15 mm-fade-up hover:-translate-y-0.5 transition-transform" data-testid="home-letter-arrived">
      <div className="text-4xl" aria-hidden>💌</div>
      <div className="flex-1">
        <div className="font-semibold">A letter from your past self has arrived</div>
        <div className="text-sm text-[#7A6B90]">
          Written {new Date(l.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}{l.delivered_via === "hard_day" ? ", for a day like today" : ""}.
          {u.count > 1 ? ` ${u.count} letters are waiting.` : ""}
        </div>
      </div>
      <span className="mm-btn !py-2 !px-4 text-sm shrink-0">Open</span>
    </Link>
  );
};
